<h1 mat-dialog-title>{{data.title}}</h1>

<div mat-dialog-content>
  <p style="    text-align: -webkit-center;
  ">{{data.subTitle}}</p>
</div>

<div style="    justify-content: center;
margin-top: -13px;" mat-dialog-actions>
  <button mat-button mat-dialog-close>Okay</button>
</div>
